import { useEffect } from 'react';

const StrataLogin = () => {
  useEffect(() => {
    window.location.href =
      'https://korecki.securecafe.com/residentservices/korecki-condocafe/userlogin.aspx';
  }, []);

  return null;
};

export default StrataLogin;